import React, { useEffect, useState } from "react";
import BunkeyApi from "../../api/BunkeyAPI";

function RightsDownload({ itemSelected, workclient, user, modules, keyCollection, intl }) {
  const [rightsInfo, setRightsInfo] = useState(null);
  const isSharedPage = keyCollection === "assetsPublicShared";
  const useRightsActive = Boolean(
    modules && modules.some(module => module.name === "useRights" && module.activate)
  );

  useEffect(() => {
    if (isSharedPage || !user || !itemSelected || !itemSelected._id || !useRightsActive) {
      setRightsInfo(null);
      return undefined;
    }

    let cancelled = false;
    setRightsInfo(null);
    BunkeyApi({
      url: `/clients/${workclient}/rights/assets/${itemSelected._id}?userid=${user._id}`,
      method: "GET"
    })
      .then(resp => {
        if (!cancelled) setRightsInfo(resp.data);
      })
      .catch(() => {
        if (!cancelled) setRightsInfo(null);
      });

    return () => {
      cancelled = true;
    };
  }, [
    itemSelected && itemSelected._id,
    itemSelected && itemSelected.rightsState,
    workclient,
    user && user._id,
    isSharedPage,
    useRightsActive
  ]);

  if (isSharedPage || !user || !useRightsActive || !rightsInfo) return null;

  return (
    <div className="rights-detail-download">
      <div className="rights-detail-download__title">
        {intl.formatMessage({ id: "rights_download_title" })}
      </div>
      <div
        className="rights-detail-download__name"
        title={rightsInfo.downloadName || rightsInfo.name || itemSelected.name}
      >
        <span className="rights-detail-download__label">
          {intl.formatMessage({ id: "rights_download_name" })}
        </span>
        <span className="rights-detail-download__filename">
          {rightsInfo.downloadName || rightsInfo.name || itemSelected.name || "—"}
        </span>
      </div>
      {rightsInfo.canDownload === false && (
        <div className="rights-detail-download__blocked">
          <strong>{intl.formatMessage({ id: "rights_download_expired_detail" })}</strong>
        </div>
      )}
    </div>
  );
}

export default RightsDownload;
